<template>
  <path
    class="Arc"
    :transform="`translate(${x}, ${y})`"
    :fill="fill"
    @click="onClick"
    @mouseover="onMouseover"
    @mouseout="onMouseout"
  />
</template>

<script>
import Datum from './datum.vue';

export default {
  name: 'DatalasArc',

  extends: Datum,
};
</script>
